<template>
  <div>
    <div v-if="!loading" class="home-pag">
      <section class="event team-sec team-grid speaker set-relative" id="speaker">
        <div class="container" style="padding:45px 55px; margin:auto;border: 1px solid black;">
          <div class="row bg">
             <div class="row">
            <div class="col-md-2 text-center">
              <img alt="Logo" class="university-logo" src="https://cu-admission.sgp1.digitaloceanspaces.com/logo/admit_logo.png">
            </div>
            <div class="col-md-8 text-center">
              <div class="bangla-text university-name">চট্টগ্রাম বিশ্ববিদ্যালয়</div>
              <div class="bangla-text admission-title font-12">১ম বর্ষ স্নাতক (সম্মান) ভর্তি পরীক্ষা, শিক্ষাবর্ষ: ২০২৬-২০২৭</div>
              <div class="bangla-text admit-card-title">প্রবেশ পত্র</div>
              <div class="bangla-text unit-title"> {{ studentInfo.unit }} {{ studentInfo.unit.charAt(1) ? 'Sub-' : '' }} Unit </div>
            </div>
            <div class="col-md-2 text-center">
              <div class="qrcode" id="qrCodeUrl"></div>
            </div>
          </div>


          <div class="row">
            <div class="col-md-12 text-center subject-choice-header">
              <!-- <div class="bangla-text font-12">
                  পরীক্ষা কেন্দ্রে প্রবেশের জন্য এই প্রবেশপত্রের এক কপি প্রিন্ট অবশ্যই সাথে আনতে হবে। উত্তীর্ণ পরীক্ষার্থীদের সাক্ষাৎকার ও অন্যান্য ভর্তি </br> কার্যক্রমেও এই প্রবেশপত্রের প্রয়োজন হবে বিধায়  ডাউনলোডকৃত প্রবেশপত্রটির ডিজিটাল ও প্রিন্ট কপি সংরক্ষণ করতে হবে। 
              </div> -->
              
            </div>
            <!-- <div class="col-md-12"> -->
              <!-- <div class="row">
                <div class="col-md-2" style="width:25%; text-align: center!important;">
                  <img align="left" alt="" style="width:75px;padding-top: 20px; margin-bottom:5px" class="img-fluid"
                    src="../../theme-assets/images/logo/cu_logo_black.png">
                </div>
                <div class="col-md-2" style="width:50%;  text-align: center!important;">
                  <p class="d-inline-block m-auto 'Tiro Bangla', serif"
                    style="font-size:17px;color:black;borderx:1px solid black;padding:7px; line-height: 19px; font-family: 'Tiro Bangla', serif; text-align:center">
                    &nbsp;</p>
                </div>
                <div class="col-md-2" style="width:25%; text-align: center!important;">
                  <div align="right" class="qrcode ml-4 mr-4" ref="qrCodeUrl" id="qrCodeUrl">
                    <p align="right"
                      style="color: black;font-size: 18px;margin-bottom: 2px;font-family:'Times New Roman', Times, serif;">
                      {{ studentInfo.unit }} {{ studentInfo.unit.charAt(1) ? 'Sub-' : '' }}Unit <span
                        v-if="studentInfo.medium == 'English'">({{ studentInfo.medium }})</span>
                    </p>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- <div class="col-md-8 text-center">
              <div class="bangla-text university-name">চট্টগ্রাম বিশ্ববিদ্যালয়</div>
              <div class="bangla-text admission-title font-12">১ম বর্ষ স্নাতক (সম্মান) ভর্তি পরীক্ষা, শিক্ষাবর্ষ:
                ২০২৬-২০২৭</div>
              <div class="bangla-text admit-card-title">প্রবেশ পত্র</div>
              <div class="bangla-text unit-title">${selected_unit}</div>
            </div> -->
            <!-- <div class="col-md-12" style="margin-top:-30px">
                    <h4 style="text-transform: unset;color:black;font-family: 'Tiro Bangla', serif;font-weight:bold;font-size:30px" align="center">চট্টগ্রাম বিশ্ববিদ্যালয়</h4>
                    <p style="text-align:center;font-size: large;font-family: 'Tiro Bangla', serif;color:black;padding:10px">১ম বর্ষ স্নাতক (সম্মান) ভর্তি পরীক্ষা, শিক্ষাবর্ষ: ২০২৬-২০২৭</p>
                </div> -->
            <!-- <div class="col-md-12">
              <p
                style="text-align:center;font-size: 27px;font-weight:bold;font-family: 'Tiro Bangla', serif;color:black;padding:10px;margin-bottom:10px">
                প্রবেশপত্র</p>
              <p style="text-align:center;margin-bottom:10px" class="text-danger">
                      <span style="border: 3px solid red;border-radius: 10px;padding:5px">
                        <b>Test Data</b>
                      </span>
                    </p>-->
            </div>
            <div class="col-md-6">
              <p style="font-size: 20px;color:black;font-family:'Times New Roman', Times, serif">Admission Test Roll No:
                <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{
                  studentInfo.exam_roll
                    ? studentInfo.exam_roll.charAt(0) : '?'}}</span>
                <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{
                  studentInfo.exam_roll
                    ? studentInfo.exam_roll.charAt(1) : '?'}}</span>
                <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{
                  studentInfo.exam_roll
                    ? studentInfo.exam_roll.charAt(2) : '?'}}</span>
                <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{
                  studentInfo.exam_roll
                    ? studentInfo.exam_roll.charAt(3) : '?'}}</span>
                <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{
                  studentInfo.exam_roll
                    ? studentInfo.exam_roll.charAt(4) : '?'}}</span>
                <span style="border: 2px solid black;padding: 2px 7px 2px 7px;">{{ studentInfo.exam_roll ?
                  studentInfo.exam_roll.charAt(5) : '?' }}</span>
              </p>
            </div>
            <div class="col-md-6">
              <p style="font-size: 20px;color:black;text-align:right;font-family:'Times New Roman', Times, serif">
                Application ID:
                <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{
                  studentInfo.applicant_no
                    ? studentInfo.applicant_no.charAt(0) : '?'}}</span>
                <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{
                  studentInfo.applicant_no
                    ? studentInfo.applicant_no.charAt(1) : '?'}}</span>
                <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{
                  studentInfo.applicant_no
                    ? studentInfo.applicant_no.charAt(2) : '?'}}</span>
                <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{
                  studentInfo.applicant_no
                    ? studentInfo.applicant_no.charAt(3) : '?'}}</span>
                <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{
                  studentInfo.applicant_no
                    ? studentInfo.applicant_no.charAt(4) : '?'}}</span>
                <span style="border: 2px solid black;padding: 2px 7px 2px 7px;">{{ studentInfo.applicant_no ?
                  studentInfo.applicant_no.charAt(5) : '?' }}</span>
              </p>
            </div>
            <div class="col-md-8">
              <p style="color:black;padding:25px 10px 10px 0px;font-family: 'Tiro Bangla', serif;">পরীক্ষার্থীর নাম:
                <span style="font-family:'Times New Roman', Times, serif">{{ studentInfo.name }}</span>
              </p>
              <p style="color:black;padding:15px 10px 10px 0px;font-family: 'Tiro Bangla', serif;">পিতার নাম: <span
                  style="font-family:'Times New Roman', Times, serif">{{ studentInfo.father_name }}</span></p>
              <p style="color:black;padding:15px 10px 10px 0px;font-family: 'Tiro Bangla', serif;">মাতার নাম: <span
                  style="font-family:'Times New Roman', Times, serif">{{ studentInfo.mother_name }}</span></p>
              <p
                style="margin-top: 10px; color:black;padding:5px;text-align:center;border:2px solid black;max-width:300px;margin-top:5px;font-family: 'Tiro Bangla', serif;">
                পরীক্ষার অঞ্চল: {{ studentInfo.exam_center_name }}<br> পরীক্ষার তারিখ: {{ studentInfo.exam_date }}<br>
                সময়:
                {{ studentInfo.exam_time }}
              </p>
            </div>
            <div class="col-md-4" style="padding-top:10px; margin-top:25px; text-align:center;">
              <img alt="" style="width:180px;margin-bottom:5px; border: 1px solid gray; padding:1px;" class="img-fluid"
                :src="studentInfo.photo">
              <p>
                <img alt="" style="padding:1px;"
                  class="img-fluid" :src="studentInfo.signature">
              </p>
              <p
                style="border:1px black;border-top-style:dashed;color:black;margin-top:6px;margin-left:15%; margin-right:15%; font-family:'Tiro Bangla', serif;text-align:center;">
                পরীক্ষার্থীর স্বাক্ষর</p>
            </div>
            <div v-if="!openSeatPlan" class="col-md-12 row bangla-text instructions-list" style="margin-top: 25px;">
              <div class="instruction-item">১। উত্তরপত্রে লেখার কাজে কালো কালির বলপয়েন্ট কলম ব্যবহার করতে হবে। পেন্সিল
                অথবা তরল কালির কলম ব্যবহার সম্পূর্ণভাবে নিষিদ্ধ।</div>

              <div class="instruction-item">২। ⁠পরীক্ষা কেন্দ্রে প্রবেশের জন্য ও পরীক্ষায় অংশগ্রহনের জন্য এই
                প্রবেশপত্রের এক কপি রঙিন অথবা সাদাকালো প্রিন্ট এবং উচ্চ মাধ্যমিক শিক্ষা বোর্ডের মূল রেজিস্ট্রেশন কার্ড
                অথবা <span class="english-text">A</span>-লেভেলের <span class="english-text">Statement of Entry</span>-র
                মূল কপি সাথে আনতে হবে। পরীক্ষায় অংশগ্রহনের সময় পরীক্ষা কেন্দ্রের পরিদর্শককে চাহিদা অনুযায়ী এ সকল
                কাগজপত্র প্রদর্শন করতে হবে।</div>

              <div class="instruction-item">৩। পরীক্ষায় সহায়ক হিসাবে ব্যবহারের জন্য <span
                  class="english-text">FX-100</span> বা এর নিচের মানের ক্যালকুলেটর ব্যবহার করা যাবে, তবে সিম বা অন্য কোন
                যোগাযোগ প্রযুক্তি সমৃদ্ধ এবং প্রোগ্রামেবল ক্যালকুলেটর ব্যবহার করা যাবে না। পরীক্ষার সময় মোবাইল ফোন,
                স্মার্ট ওয়াচ, যে কোন ধরনের যোগাযোগ যন্ত্র বা অন্য ইলেকট্রনিক ডিভাইস/গ্যাজেট সাথে রাখা সম্পূর্ণ নিষিদ্ধ।
              </div>

              <div class="instruction-item">৪। ⁠সনাক্তকরণের স্বার্থে পরীক্ষার্থীর মুখমন্ডল ও উভয় কান দৃশ্যমান থাকতে
                হবে।</div>

              <div class="instruction-item">৫। ⁠আবেদনের সময় (অথবা পরবর্তীতে সংশোধনের সময়) ভর্তির ওয়েবসাইটে আপলোডকৃত
                ছবি ও স্বাক্ষরই চুড়ান্ত বলে গণ্য হবে। সংশোধনের নির্ধারিত সময় শেষ হবার পর কোন অবস্থাতেই ছবি বা স্বাক্ষর
                পরিবর্তন করা যাবে না।</div>

              <div class="instruction-item">৬। পরীক্ষার হলে পরিদর্শক বা প্রধান পরিদর্শকের সিদ্ধান্তই চুড়ান্ত বলে গণ্য
                হবে।</div>

              <div class="instruction-item">৭। পরীক্ষার কেন্দ্র, ভবন, কক্ষ নম্বর; পরীক্ষার ফলাফল; সাক্ষাৎকারের তারিখ ও
                স্থান; সাময়িক ও চুড়ান্ত ভর্তির যাবতীয় তথ্য ইত্যাদি উপযুক্ত সময়ে অ্যাডমিশান ওয়েবসাইটে ( <span
                  class="english-text">admission.cu.ac.bd</span> ) প্রদর্শিত হবে। পরীক্ষার্থীদের নিজ নিজ দায়িত্বে
                যথাসময়ে ওয়েবসাইট হতে তথ্য সংগ্রহ করতে হবে।</div>

              <div class="instruction-item">৮। ক্ষেত্রবিশেষে পরীক্ষার্থীদের প্রদত্ত মোবাইল ফোনে ক্ষুদ্র বার্তার মাধ্যমে
                জরূরী সংবাদ প্রদান করা হবে, আবেদনের সময় থেকে ভর্তি প্রক্রিয়া সম্পূর্ণ শেষ না হওয়া পর্যন্ত মোবাইল
                ফোনটি সচল রাখার দায়িত্ব সংশ্লিষ্ট পরীক্ষার্থীর।</div>


            </div>
            <div v-else class="col-md-12 row" style="margin-top: 25px;">
              <div class="card" style="margin-bottom:10px">
                <div class="card-header bg-dark text-white" style="font-weight:boldx">
                  <div class="row">
                    <div class="col-md-12" style="font-weight:bold; text-align:center;">Seat Plan</div>
                  </div>
                </div>
                <div class="card-body">
                  <table class="table" style="font-weight: bold;margin:auto">
                    <tr>
                      <td class="count-desc">Center</td>
                      <td class="count-desc">:</td>
                      <td class="count-desc">
                        {{ studentInfo.center }}, {{ studentInfo.exam_center_name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="count-desc">Building</td>
                      <td class="count-desc">:</td>
                      <td class="count-desc">
                        {{ studentInfo.building }}
                      </td>
                    </tr>
                    <tr>
                      <td class="count-desc">Room</td>
                      <td class="count-desc">:</td>
                      <td class="count-desc">
                        {{ studentInfo.room + ', ' + studentInfo.floor }}
                      </td>
                    </tr>
                    <!--tr>
                          <td class="count-desc">Shift</td>
                          <td class="count-desc">:</td>
                          <td class="count-desc">{{studentInfo.shift}}</td>
                        </tr-->
                    <tr>
                      <td class="count-desc">Date</td>
                      <td class="count-desc">:</td>
                      <td class="count-desc">{{ studentInfo.exam_date }}</td>
                    </tr>
                    <tr>
                      <td class="count-desc">Time</td>
                      <td class="count-desc">:</td>
                      <td class="count-desc">{{ studentInfo.exam_time }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="row">
                <div class="col-md-6" style="position:relative">
                  <p
                    style="position:absolute;bottom:0;font-weight:boldx;color:black;font-family: 'Tiro Bangla', serif;font-size:17px;">
                    ডাউনলোডের তারিখ: <span style="font-weight: bold;">{{ studentInfo.admitcard_download_date }}</span>
                    <span>
                      <br /><br />
                      <span style="font-style:italic;">Powered by <b>ICT Cell, University of Chittagong</b></span>
                    </span>
                  </p>
                </div>
                <div class="col-md-6" style="margin-top:10px;text-align:right">
                  <img alt="" style="width:160px;margin-bottom:5px;margin-right:5px" class="img-fluid"
                    :src="studentInfo.co_ordinator_signature">
                  <p
                    style="text-align:right;line-height:1.4;color:black;padding-top:10px;font-family: 'Tiro Bangla', serif;font-size:17px">
                    {{ studentInfo.unit_co_ordinator }}
                    <br> কো-অর্ডিনেটর
                    <br> <span style="font-family:'Times New Roman', Times, serif">{{ studentInfo.unit }}</span>
                    {{ studentInfo.unit.charAt(1) ? 'উপ-' : '' }}ইউনিট ভর্তি কমিটি
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div v-else>
      <loader class="loader"></loader> <br />
    </div>
  </div>
</template>

<script>
import Loader from '../Helper/Loader'
import Banner from '../Partial/Banner'
import { CHECK_ADMIT_CARD, GET_DOCS } from '../../const/api'
import { GET } from '../../utils/Request'
import QRCode from 'qrcodejs2'
export default {
  name: 'CheckAdmitCard',
  components: { Loader, Banner },
  data() {
    return {
      loading: false,
      Schedule: '',
      firstTimeLoad: true,
      qrText: '',
      openSeatPlan: false,
      studentInfo: {
        unit: '',
        applicant_no: '',
        co_ordinator_signature: '',
        exam_date: '',
        exam_center: '',
        exam_center_name: '',
        exam_roll: '',
        exam_time: '',
        father_name: '',
        group: '',
        mother_name: '',
        name: '',
        photo: '',
        signature: '',
        status: '',
        unit_co_ordinator: '',
        medium: '',
        admitcard_download_date: '',
        admitcard_download_time: '',
        center: '',
        bulding: '',
        floor: '',
        room: '',
        shift: ''
      }
    }
  },
  computed: {
    isOnHomepage() {
      let routeName = this.$route.name
      return routeName == 'home' ? true : false
    }
  },
  created() {
    this.getDocs();
  },
  mounted() {
  },
  methods: {

    async getDocs() {

      /*this.$route.params.hash = this.$route.params.hash;*/
      var data = await GET(CHECK_ADMIT_CARD + this.$route.params.hash);
      /*console.log('getDocs'); console.log(data.data);*/

      if (data.data.status == 'success') {
        this.studentInfo.unit = '' + data.data.unit;
        this.studentInfo.applicant_no = '' + data.data.application_id;
        this.studentInfo.exam_date = data.data.exam_date;
        this.studentInfo.exam_roll = '' + data.data.exam_roll;
        this.studentInfo.exam_center = '' + data.data.exam_center;
        this.studentInfo.exam_center_name = '' + data.data.exam_center_name;
        this.studentInfo.exam_time = data.data.exam_time;
        this.studentInfo.father_name = data.data.father_name;
        this.studentInfo.group = data.data.group;
        this.studentInfo.mother_name = data.data.mother_name;
        this.studentInfo.name = data.data.name;
        this.studentInfo.medium = data.data.medium;
        this.studentInfo.photo = data.data.photo;
        this.studentInfo.signature = data.data.signature;
        this.studentInfo.unit_co_ordinator = data.data.unit_co_ordinator;
        this.studentInfo.co_ordinator_signature = data.data.co_ordinator_signature;

        this.openSeatPlan = data.data.openSeatPlan;

        this.studentInfo.center = data.data.center;
        this.studentInfo.building = data.data.building;
        this.studentInfo.floor = data.data.floor;
        this.studentInfo.room = data.data.room;
        this.studentInfo.shift = data.data.shift;

        let today = new Date();

        this.studentInfo.admitcard_download_date = data.data.download_date;

        /*if(data.data.download_date){
          let downloadDate = data.data.download_date;
          downloadDate=downloadDate.split('T')[0]
          this.studentInfo.admitcard_download_date = downloadDate;
        } else{
          this.studentInfo.admitcard_download_date = today.toDateString();
        }*/

        if (data.data.download_time) {
          this.studentInfo.admitcard_download_time = data.data.download_time;
        } else {
          let amOrPm = 'AM';
          let hour = today.getHours();
          if (hour > 11) {
            amOrPm = 'PM';
            if (hour > 12) {
              hour -= 12;
            }
          }
          let mins = today.getMinutes();
          if (mins < 10) {
            mins = '0' + mins;
          }
          this.studentInfo.admitcard_download_time = hour + ":" + mins + amOrPm;
          // this.studentInfo.admitcard_download_time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        }

        /*this.qrText = 'Unit:'+this.$route.params.unit
          + ',Name:'+ this.studentInfo.name 
          + ', Father Name:'+ this.studentInfo.father_name 
          + ', Mother Name:'+ this.studentInfo.mother_name 
          + ',Roll:'+ data.data.exam_roll
          + ',AppID:'+ this.studentInfo.applicant_no
          + ',Medium:' + this.studentInfo.medium
          + ',Exam Date&Time:' + this.studentInfo.exam_date+' '+this.studentInfo.exam_time;*/

        /*this.qrText = 'http://dev.front.cu.ac.bd/check-admit-card/' + data.data.hash_key;*/
        this.qrText = `${process.env.VUE_APP_FRONTEND_URL}check-admit-card/${data.data.hash_key}`;
      } else {
        this.$iziToast.error({
          message: data.data.message
        });
        this.goForUrl('/');
      }
      this.timeoutForLoading();
    },

    goForUrl(url) {
      this.$router.replace(url)
    },

    topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    timeoutForLoading() {
      if (this.firstTimeLoad) {
        this.$nextTick(() => {
          setTimeout(
            function () {
              this.loading = false;
              this.getQR();
              /*window.print();*/
            }.bind(this),
            3000
          )
        })
      }
      this.firstTimeLoad = false
    },
    getQR() {
      let canvasDiv = document.createElement("div"); //New dom element, if there is only one page, you can use the page element directly
      canvasDiv.id = 'canvas'
      document.getElementById('qrCodeUrl').append(canvasDiv);
      /*qrcode generates QR code*/
      let qrcode = new QRCode('canvas', {
        text: this.qrText,
        width: 100,
        height: 100,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      });
      /* Get the canvas element */
      let canvas = document.getElementById('canvas').querySelector('canvas')
      var dataURL = canvas.toDataURL();
      canvas = null;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 @import url('https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&family=Tiro+Bangla:ital@0;1&family=Victor+Mono:ital,wght@0,500;1,500&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-size: 12px;
  line-height: 1.3;
  color: black;
}

.bangla-text { font-family: "Tiro Bangla", serif; font-weight: 400; }
.bangla-text-bold { font-family: "Tiro Bangla", serif; font-weight: 600; }
.english-text { /*font-family: "Courier Prime", monospace;*/ font-family: "Roboto Condensed", sans-serif; font-weight: 400; }
.english-text-bold { /*font-family: "Courier Prime", monospace;*/ font-family: "Roboto Condensed", sans-serif; font-weight: 700; }

.victor-mono-digit {
  font-family: "Victor Mono", monospace;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

 .container { width: 80%; height: 80%; padding: 70px 50px 10px 50px; margin: auto; }
/* .row { display: flex; flex-wrap: wrap; margin: 0; } */ 
.col-md-2, .col-md-6, .col-md-8, .col-md-12 { padding: 0 5px; margin-bottom: 5px; }
.col-md-2 { flex: 0 0 16.6667%; max-width: 16.6667%; }
.col-md-6 { flex: 0 0 50%; max-width: 50%; }
.col-md-8 { flex: 0 0 66.6667%; max-width: 66.6667%; }
.col-md-12 { flex: 0 0 100%; max-width: 100%; }

.text-center { text-align: center; }
.text-left { text-align: left; }
.text-right { text-align: right; }
.font-weight-bold { font-weight: bold; }

.text-center { text-align: center; }
.text-left { text-align: left; }
.text-right { text-align: right; }
.font-weight-bold { font-weight: bold; }

.font-12{
  font-size:12px;
}
.font-14{
  font-size:11px;
}
.university-name {
  font-size: 23px;
  line-height: 1.4;
  margin-bottom: 2px;
}
.admission-title { font-size: 12px; margin-bottom: 5px; }
.university-logo { max-width: 100%;height: auto;max-height: 105px;float: left; }


.roll-application-row {
  display: flex;
  justify-content: space-between; /* left & right most */
  align-items: center;
  width: 100%;          /* full width */
  margin: 10px 0 5px 0;            /* remove Bootstrap row margin */
  padding: 0;           /* remove Bootstrap row padding */
}

.roll-number-section,
.application-id-section {
  font-size: 14px;
  color: black;
  margin: 0;
  padding: 0;
}



.qrcode { width: 80px; height: 80px; margin: auto; }

.unit-text {
  color: black;
  font-size: 14px;
  margin-top: 20px;
}

.student-details-row {
  display: flex;
  width: 100%;
  margin: 10px 0;
  align-items: flex-start; /* aligns top edges */
}

.student-info-column {
  flex: 1 1 auto; /* take remaining space */
  padding-right: 15px;
  min-width: 0;
}

.photo-signature-column {
  flex: 0 0 auto; /* fixed width, don't shrink or grow */
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
}



        .student-info-row {
          color: black;
          padding: 8px 0;
          font-size: 13px;
          line-height: 1.3;
        }

        .exam-info-box {
          color: black;
          padding: 8px;
          text-align: center;
          border: 1.5px solid black;
          max-width: 250px;
          margin-top: 10px;
          font-size: 13px;
          line-height: 1.6;
        }

        .student-photo {
          width: 130px;
          height: auto;
          border: 1px solid gray;
          padding: 1px;
          margin-bottom: 10px;
        }

        .student-signature {
          width: 110px;
          height: auto;
          display: block;
        }

        .signature-label {
          border-top: 1px dashed black;
          width: 110px;
          margin: 1px auto 0;
          font-size: 11px;
          padding-top: 1px;
        }


.instructions-row {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          width: 95%;
          margin: 10px 0 0 10px;
        }


        .instructions-list {
          width: 100%;
          text-align: justify;
          padding-left: 18px; 
          list-style-position: outside;
        }

        .instructions-list li {
          margin-bottom: 5px;
          line-height: 1.4;
          font-size: 11px;
        }

.count-desc { font-family: 'Times New Roman', Times, serif; font-weight: bold; }
.roll-digit { border: 1px solid black; padding: 1px 4px; font-size: 14px; display: inline-block; margin-right: 2px; }
.roll-digit-last { border-right: 1px solid black;font-size: 14px; }
span[style*="border: 2px solid black"] { display: inline-block; }

p { margin: 2px 0; }

.subject-choice-header {
  display: flex;
  flex-direction: column; /* stack items vertically */
  justify-content: center; /* center vertically (optional) */
  align-items: center;     /* center horizontally */
  gap: 5px; /* space between title and badge */
  margin-top: 10px;
  margin-bottom: 8px;
}

.unit-quota-badge {
  border: 1px solid black;
  border-radius: 5px;
  padding: 2px 6px;
  font-size: 12px;
  display: inline-block;
}

/* Container rows */
.subject-choice-row {
  display: flex;
  flex-wrap: nowrap;
  border-bottom: 1px solid #ddd;
  padding: 4px 0;
}

/* Header row */
.subject-choice-header-row {
  background-color: #eef7fb;
  font-weight: bold;
}

/* Cells */
.subject-choice-cell {
  padding: 2px 4px;
  font-size: 12px;
  display: flex;
  align-items: center;
}

/* Specific column widths */
.code-cell { flex: 0 0 25%; text-align: center; }
.title-cell { flex: 0 0 50%; text-align: left; }
.serial-cell { flex: 0 0 25%; text-align: center; }

/* Optional styling for card body */
.card-body {
  padding: 5px 10px;
}

.applicant-info-row {
  display: flex;
  flex-wrap: nowrap;
  margin-bottom: 4px;
  font-size: 12px;
}

.applicant-info-label {
  flex: 0 0 30%; /* adjust width of label column */
  font-weight: bold;
}

.applicant-info-separator {
  flex: 0 0 5%;  /* small space for ':' */
  text-align: center;
}

.applicant-info-value {
  flex: 1 0 65%; /* remaining width */
}


.admit-card-title {
  width: 100%;
  text-align: center;
  font-size: 29px;
  color: black;
  margin: 10px 0 5px 0;
  line-height: 1;
}

.unit-title{
  width: 100%;
  text-align: center;
  font-size: 21px;
  color: black;
  margin: 10px 0 5px 0;
  line-height: 1;
}

.instructions-wrapper {
  font-size: 12px; /* override works fine now */
  margin: 0;
  padding: 0;
}

.instruction-item {
  margin-bottom: 6px;
  line-height: 1.5;
  display: block;
}


.instructions-wrapper a {
  text-decoration: none;
  color: #007bff;
}


.footer-row {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          width: 100%;
          position:relative;
          bottom:-80px;

        }

        .download-info {
          color: black;
          font-size: 12px;
          line-height: 1.4;
        }

        .download-date {
          font-weight: bold;
        }

        .powered-by-text {
          font-style: italic;
          font-size: 10px;
        }

        .coordinator-signature {
          width: 120px;
          height: auto;
          max-height:80px;
          margin-bottom: 3px;
        }

        .coordinator-info {
          text-align: center;
          line-height: 1.3;
          color: black;
          font-size: 12px;
        }

        @page { size: A4; margin: 15mm 10mm; }
.bg {
  top: 200px;
  width: 100%;
  /* Adjust size as needed */
  height: 100%;
  /* Adjust size as needed */
  background-image: url('https://cu-admission.sgp1.cdn.digitaloceanspaces.com/logo/cu_watermark.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 30%;
}

.loader {
  margin-top: 20%;
}

.pdf-app {
  width: 100%;
  height: 182.5vh;
}

.d-flex {
  padding: 10px;
  margin: 10px;
  -webkit-box-shadow: 1px 0 15px 2px #c1b3b3;
  box-shadow: 1px 0 15px 2px #c1b3b3;
}

.home-page {
  background: url(../../assets/bg.svg);
  background-size: cover;
  /*font-family: 'Poppins', sans-serif;*/
}

.home-page section {
  padding: 5px 0px;
}

/* Header */


.img-fluid {
  max-width: 100%;
}


/* advantages */
.advantages {
  -webkit-box-shadow: 0px 3px 10px 0px #dadada;
  -moz-box-shadow: 0px 3px 10px 0px #dadada;
  box-shadow: 0px 3px 10px 0px #dadada;
}

.main-img-logo {
  background: rgba(245, 222, 179, 0.5);
  margin: 4px;
  padding: 8px;
}

* {
  box-sizing: border-box;
}
</style>
